const SESSION_KEY = "livis_log_session_id";

const randomId = (): string => {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

/**
 * One id per browser tab, used only to correlate events server-side (which
 * clicks/API calls/errors belong to the same session). Not persisted beyond
 * the tab's sessionStorage — never written to any client-visible log file.
 */
export const getSessionId = (): string => {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = randomId();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return randomId();
  }
};
